import { TUser } from "core/models/auth.model";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface AuthState {
  user: TUser | null;
}

const initialState: AuthState = {
  user: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setUser(state, action: PayloadAction<any>) {
      state.user = action.payload;
    },
  },
});

export const { setUser } = authSlice.actions;

export const authReducer = authSlice.reducer;
